
import {reminderStage} from "../services/whatsappService";

function CreditCard({ onReminder, onShare, credit, formatMoney, getColorEstado, onRefinance, onEdit, onCancel, onActivateLateFee, onRemoveLateFee }) {
  const notice = reminderStage(credit);
  const creditCode = `${String(credit.nivelRefinanciacion || 0).padStart(2, "0")}-${String(credit.codigoDirecto || 0).padStart(4, "0")}`;
  const todayDate = new Date().toISOString().slice(0, 10);
  const dueDate = credit.fechaVencimiento ? new Date(credit.fechaVencimiento).toISOString().slice(0, 10) : null;
  const isDue = Boolean(dueDate && todayDate >= dueDate);
  const deudaTotalActual = credit.total + (credit.recargoAcumulado || 0);
  const porcentajePagado = deudaTotalActual > 0
    ? Math.min(100, Math.round(((credit.totalPagado || 0) / deudaTotalActual) * 100))
    : 0;

  const badge = {
    PAGADO: ["#e4f6ec","#238456"],
    MOROSO: ["#fde9e9","#c74444"],
    DEUDA: ["#fff2d9","#a16c12"],
    PAGO50: ["#e6efff","#4168b7"],
    REFINANCIADO: ["#eee9fb","#7254ad"],
    CANCELADO: ["#eef0f3", "#626a76"],
  }[credit.estado] || ["#eef0f3","#626a76"];

  return (
    <article className="cc-credit-card">
      <div className="cc-credit-head">
        <div>
          <div className="cc-list-label">Crédito <span className="cc-credit-code">{creditCode}</span></div>
          <strong className="cc-credit-amount">{formatMoney(credit.total)}</strong>
        </div>
        <span className="cc-badge" style={{backgroundColor:badge[0],color:badge[1]}}>{credit.estado}</span>
      </div>

      <div className="cc-credit-grid">
        <div><span>Capital</span><strong>{formatMoney(credit.capital)}</strong></div>
        <div><span>Interés {credit.tipoInteres === "FIJO" ? "fijo" : "aplicado"}</span><strong>{credit.tipoInteres === "FIJO" ? formatMoney(credit.interes) : credit.capital > 0 ? `${new Intl.NumberFormat("es-AR", { maximumFractionDigits: 2 }).format(credit.interes / credit.capital * 100)}%` : "—"}</strong></div>
        <div><span>Pagado</span><strong>{formatMoney(credit.totalPagado || 0)}</strong></div>
        <div><span>Saldo pendiente</span><strong>{formatMoney(credit.saldoPendiente)}</strong></div>
        <div><span>Cuota</span><strong>{formatMoney(credit.valorCuota)}</strong></div>
        <div><span>Cuotas</span><strong>{credit.cuotas}</strong></div>
        <div><span>Operador</span><strong>{credit.operador ? `${credit.operador.nombre} ${credit.operador.apellido}` : "-"}</strong></div>
        <div><span>Comisión</span><strong>{formatMoney(credit.comisionTotal)}</strong></div>
        <div><span>Otorgamiento</span><strong>{credit.fechaInicio ? new Date(credit.fechaInicio).toLocaleDateString() : "-"}</strong></div>
        <div><span>Vencimiento</span><strong>{credit.fechaVencimiento ? new Date(credit.fechaVencimiento).toLocaleDateString() : "-"}</strong></div>
      </div>


      {onShare && <button className="cc-btn cc-btn-secondary" onClick={() => onShare(credit)}>Compartir detalle por WhatsApp</button>}
      {onReminder && credit.activo && credit.saldoPendiente>0 && !['PAGADO','CANCELADO','REFINANCIADO'].includes(credit.estado) && <div style={{margin:'12px 0'}}>
        {notice && <p style={{color:'#a16c12'}}>Aviso pendiente sugerido: {({before:'vence en 7 días',today:'vence hoy',overdue:'vencido'})[notice]}</p>}
        <label>Aviso por WhatsApp<select aria-label="Tipo de aviso por WhatsApp" value="" onChange={e=>{if(e.target.value)onReminder(credit,e.target.value);}} style={{display:'block',padding:10,width:'100%'}}>
          <option value="">Preparar aviso…</option>
          <option value="before" disabled={notice!=="before"}>Recordatorio: 7 días antes</option>
          <option value="today" disabled={notice!=="today"}>Recordatorio: vence hoy</option>
          <option value="overdue" disabled={notice!=="overdue"}>Aviso: crédito vencido</option>
        </select></label>
      </div>}
      <div className="cc-progress-row">
        <div className="cc-progress-label"><span>Progreso de pago</span><strong>{porcentajePagado}%</strong></div>
        <div className="cc-progress"><div style={{width:`${porcentajePagado}%`}} /></div>
      </div>

      {credit.activo && credit.estado !== "PAGADO" && credit.estado !== "REFINANCIADO" && (
        <button className="cc-btn cc-btn-secondary" onClick={() => onEdit(credit)}>
          Editar valores del crédito
        </button>
      )}

      {credit.activo && credit.estado !== "PAGADO" && credit.estado !== "REFINANCIADO" &&
        credit.estado !== "CANCELADO" && (credit.totalPagado || 0) === 0 && (
        <button className="cc-btn cc-btn-secondary" onClick={() => onCancel(credit)}>
          Cancelar crédito
        </button>
      )}

      {isDue && credit.activo && !["PAGADO", "REFINANCIADO", "CANCELADO"].includes(credit.estado) &&
        (credit.morosidadAnulada || !(credit.morosidadActivada || (credit.recargoAcumulado || 0) > 0)) && (
        <button className="cc-btn cc-btn-danger" onClick={() => onActivateLateFee(credit)}>
          MOROSO
        </button>
      )}

      {isDue && credit.activo && !["PAGADO", "REFINANCIADO", "CANCELADO"].includes(credit.estado) &&
        (credit.morosidadActivada || (credit.recargoAcumulado || 0) > 0) && (
        <button className="cc-btn cc-btn-secondary" onClick={() => onRemoveLateFee(credit)}>
          NO MOROSO
        </button>
      )}

      {credit.estado === "PAGO50" && credit.saldoPendiente > 0 && (
        <div className="cc-refinance">
          <div><strong>Crédito elegible para refinanciación</strong><span>El cliente alcanzó el 50% de la deuda vigente.</span></div>
          <button className="cc-btn cc-btn-blue" onClick={()=>onRefinance(credit)}>Refinanciar</button>
        </div>
      )}
    </article>
  );
}
export default CreditCard;
